import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './app';
import './scss/core.scss';
import 'bootstrap/dist/css/bootstrap.min.css';


render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.getElementById('root'));